var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_has.js
// module id = 4
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_has.js